import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import DataTableMUI from "../../components/common/DataTable";
import { VideoColumns } from "../../services/tableColomn";
import ViewDataPopup from "./viewDataPopup";
import { useNavigate } from "react-router-dom";
import {
  getAllVideos,
  deleteVideos,
  undoDeleteVideos
} from "../../redux/slices/videoSectionSlice";

const statusOptions = [
  { value: "all", label: "ALL", color: "#2563eb" },
  { value: "active", label: "ACTIVE", color: "#388e3c" },
  { value: "inactive", label: "INACTIVE", color: "#bfa100" },
  { value: "deleted", label: "DELETED", color: "#d32f2f" },
];

const VideoSection = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { videos, loading, statusCounts, pagination } = useAppSelector(
    (state) => state.videoSection
  );

  const [viewPopupOpen, setViewPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      getAllVideos({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );
  }, [dispatch, statusFilter, page, search, itemsPerPage, sortKey, sortOrder]);

  const refetch = () =>
    dispatch(
      getAllVideos({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(1);
  };

  const handlePageChange = (newPage) => setPage(newPage);
  
  const handleView = (row) => {
    setSelectedRow(row);
    setViewPopupOpen(true);
  };

const handleEdit = (row) => {
    navigate("/video-gallery-form", { 
      state: { initialData: row } 
    });
  };


  const handleDelete = async (row) => {
    if (window.confirm("Are you sure you want to delete this video?")) {
      try {
        // Use the correct video delete action
        await dispatch(deleteVideos(row._id)).unwrap();
        refetch();
      } catch (error) {
        console.error("Delete failed:", error);
      }
    }
  };

  const handleSort = (col) => {
    if (!col.sortable) return;
    setSortKey(col.accessor);
    setSortOrder(
      sortKey === col.accessor && sortOrder === "asc" ? "desc" : "asc"
    );
    setPage(1);
  };

  const handleSearch = () => {
    setSearch(searchInput);
    setPage(1);
  };

  // Add counts to statusOptions
  const statusOpts = statusOptions.map((opt) => ({
    ...opt,
    count: statusCounts?.[opt.value] || 0,
  }));

  return (
    <div className="data-table">
      <DataTableMUI
        title="Video Gallery"
        columns={VideoColumns}
        data={videos || []}
        statusOptions={statusOpts}
        statusFilter={statusFilter}
        onStatusFilterChange={handleStatusChange}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        pagination
        itemsPerPage={itemsPerPage}
        currentPage={pagination?.page || 1}
        totalItems={pagination?.total || 0}
        setItemsPerPage={setItemsPerPage}
        onPageChange={handlePageChange}
        searchable
        searchTerm={searchInput}
        setSearchTerm={setSearchInput}
        onSearch={handleSearch}
        onAdd
        onAddClick={() => navigate("/video-gallery-form")}
        loading={loading}
        sortKey={sortKey}
        sortOrder={sortOrder}
        onSort={handleSort}
        draggable={true}
      />
      {selectedRow && (
        <ViewDataPopup
          open={viewPopupOpen}
          onClose={() => {
            setViewPopupOpen(false);
            setSelectedRow(null);
          }}
          data={selectedRow}
        />
      )}
    </div>
  );
};

export default VideoSection;
